module.exports = __webpack_public_path__ + "img/icon-play-video.d214318c.svg";